import { useState } from "react";
import { productionGateway } from "../production-gateway";
import type { TerminalBootstrap } from "../models";

export type OperatorPinLoginProps = { context: TerminalBootstrap; unlock?: boolean; onAuthenticated: () => Promise<void> };

export function useOperatorPinWorkspace({ context, unlock = false, onAuthenticated }: OperatorPinLoginProps) {
  const initialOperator = unlock ? context.session?.operatorId ?? "" : context.assignments[0]?.operatorId ?? "";
  const [operatorId, setOperatorId] = useState(initialOperator);
  const [pin, setPin] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const enterDigit = (digit: number) => {
    setError(null);
    setPin((value) => value.length < 4 ? `${value}${digit}` : value);
  };
  const clearPin = () => {
    setError(null);
    setPin("");
  };
  const submit = async () => {
    if (pin.length !== 4) { setError("PIN tam olarak 4 haneli olmalıdır."); return; }
    setSaving(true); setError(null);
    try {
      if (unlock) await productionGateway.unlockTerminal(context.terminal.terminalCode, pin);
      else await productionGateway.loginTerminal(context.terminal.terminalCode, operatorId, pin);
      setPin(""); await onAuthenticated();
    } catch (nextError) { setPin(""); setError(nextError instanceof Error ? nextError.message : "Giriş doğrulanamadı."); }
    finally { setSaving(false); }
  };
  return { operatorId, setOperatorId, pin, saving, error, enterDigit, clearPin, submit };
}
